import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import CommissionReportTableFilter from "../Filters/CommissionReportTableFilter";

import { Table, Empty, Col, Row, Tooltip, message, notification } from "antd";
import { BarsOutlined, MenuUnfoldOutlined, WarningOutlined, FileExcelOutlined } from "@ant-design/icons";
import moment from "moment";
import { ColumnHelper } from "util/TableHelper";
import { Link } from "react-router-dom";
import config from "../../util/ApiforContext";

const CommissionReport = () => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
    queryDate: "",
  });

  useEffect(() => getTableData(), [tableDataQueryOptions]);

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });
    const { skip, take, filter, queryDate } = tableDataQueryOptions;

    RequestHandler.get(
      `/PosTransaction/CommissionReport?${filter}${queryDate ? "&queryDate=" + queryDate : ""}`
    ).then((response) => {
      setTableData({
        data: response,
        total: response.length,
        loading: false,
      });
    });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
      queryDate: ""
    });
  };

  const onFinishTableFilter = (query, queryDate) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query, queryDate: queryDate };
    });
  };

  const renderCommissionDefinition = (data) => data == 0 ? (
    <Tooltip title="Komisyon tanımınız yok">
      <WarningOutlined style={{ color: "orange", fontSize: "130%" }} />
    </Tooltip>
  ) : (
    ColumnHelper.renderDecimal(data)
  );

  const renderCommissionAvarage = (definition, value) => {
    if (definition == 0) {
      return ColumnHelper.renderCommissionateDecimal(value);
    }

    return value == 0 ? (
      <p style={{ opacity: 0.5, marginBottom: 0 }}>-</p>
    ) : (
      <p style={{ color: value <= definition ? "green" : "red", marginBottom: 0 }}>{ColumnHelper.renderDecimal(value)}</p>
    )
  };

  const renderDetailButton = (bankId, installmentCount, onusNotonusId, detailDate) => (
    <Link to={`/pos-transaction/${bankId}&${installmentCount}&${onusNotonusId}&${detailDate}`} >
      <MenuUnfoldOutlined style={{ fontSize: "130%" }} />
    </Link>
  )

  const queryDate = tableDataQueryOptions.queryDate ? tableDataQueryOptions.queryDate : undefined;
  const columns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      width: "8%",
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Taksit Sayısı",
      align: "center",
      dataIndex: "installmentCount",
    },
    {
      title: "Tip",
      align: "center",
      dataIndex: "onusNotonusId",
      render: (value, row) => {
        switch (value) {
          case 1:
            return "Onus";
          case 2:
            return `NotOnus ${row.domesticOrInternational === 1 ? "- Yurtdışı" : row.domesticOrInternational === 0 ? "- Yurtiçi" : ""}`;
          default:
            return "-";
        }
      }
    },

    {
      title: moment(queryDate).startOf("month").add(-2, "month").format("MMMM YYYY"),
      children: [
        {
          title: "Anlaşılan",
          align: "center",
          dataIndex: "twoMonthBeforeDefinition",
          render: renderCommissionDefinition,
        },
        {
          title: "Gerçekleşen",
          align: "center",
          dataIndex: "twoMonthBefore",
          render: (data, row) => renderCommissionAvarage(row.twoMonthBeforeDefinition, data),
        },
        {
          title: "Detay",
          dataIndex: "bankId",
          width: "1%",
          align: "center",
          render: (data, row) => renderDetailButton(data, row.installmentCount, row.onusNotonusId, moment(queryDate).startOf("month").add(-2, "month").format("YYYY-MM-01"))
        },
      ],
    },

    {
      title: moment(queryDate).startOf("month").add(-1, "month").format("MMMM YYYY"),
      children: [
        {
          title: "Anlaşılan",
          align: "center",
          dataIndex: "oneMonthBeforeDefinition",
          render: renderCommissionDefinition,
        },
        {
          title: "Gerçekleşen",
          align: "center",
          dataIndex: "oneMonthBefore",
          render: (data, row) => renderCommissionAvarage(row.oneMonthBeforeDefinition, data),
        },
        {
          title: "Detay",
          dataIndex: "bankId",
          width: "1%",
          align: "center",
          render: (data, row) => renderDetailButton(data, row.installmentCount, row.onusNotonusId, moment(queryDate).startOf("month").add(-1, "month").format("YYYY-MM-01"))
        },
      ],
    },

    {
      title: moment(queryDate).startOf("month").format("MMMM YYYY"),
      children: [
        {
          title: "Anlaşılan",
          align: "center",
          dataIndex: "currentMonthDefinition",
          render: renderCommissionDefinition,
        },
        {
          title: "Gerçekleşen",
          align: "center",
          dataIndex: "currentMonth",
          render: (data, row) => renderCommissionAvarage(row.currentMonthDefinition, data),
        },
        {
          title: "Detay",
          dataIndex: "bankId",
          width: "1%",
          align: "center",
          render: (data, row) => renderDetailButton(data, row.installmentCount, row.onusNotonusId, moment(queryDate).startOf("month").format("YYYY-MM-01"))
        },
      ],
    },

  ];


  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);

    const { filter } = tableDataQueryOptions;
    RequestHandler.post(
      `/PosTransaction/PosCommissionDefinitionExportExcel`,
      {
        query: filter,
      },
      false
    ).then((response) => {
      hideMessage();
      if (response.success) {
        if (response) {
          window.open(
            `${config.apiUrl}/PosTransaction/PosCommissionDefinitionDownloadExcel?fileName=${response.message
            }&t=${RequestHandler.getToken()}`
          );
        }
      } else
        notification.error({
          message: response.message,
          duration: 3,
        });
    });
  };

  return (
    <>
      <Row>
        <Col xs={15} lg={20}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> KOMİSYON RAPORU
          </p>
        </Col>
        <Col xs={4} style={{ textAlign: "right", marginTop: -5 }}>
          <Tooltip title="Excel İndir" >
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>

      <CommissionReportTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
        extraText="Varsayılan olarak bu ay ve önceki 2 ayın verisi
        listelenmektedir."
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey={(record) => `${record.bankId}-${record.installmentCount}-${record.onusNotonusId}`}
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
            bordered={true}
          />
        </Col>
      </Row>
    </>
  );
};

export default CommissionReport;
